module.exports = __webpack_public_path__ + "img/seminar (28).8c283a0e.jpg";